// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__ROXvl","notes":"Notes_notes__2s1dB","note":"Notes_note__-BGXc","markdown":"Notes_markdown__4kBe0"};